import React, { Fragment, useEffect, useState } from "react";
import usePersistentFilters from "../Common/usePersistentFilters";
import { Link } from "react-router-dom";
import { Row, Col, Card, Table, Form, Button, Badge } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import api from "../../../api";
import swal from "sweetalert";

const InventoryStockLedger = () => {
 const [rows, setRows] = useState([]);
 const [warehouses, setWarehouses] = useState([]);
 const [filters, setFilters] = usePersistentFilters("inventory_stock_ledger_filters", { search: "", warehouse: "", movementType: "", page: 1, limit: 20 });
 const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 1, totalCount: 0 });
 const [loading, setLoading] = useState(false);

 useEffect(() => {
 loadWarehouses();
 }, []);

 useEffect(() => {
 fetchLedger();
 }, [filters.page, filters.limit, filters.warehouse, filters.movementType]);

 const loadWarehouses = async () => {
 try {
 const res = await api.get("/warehouses?limit=500");
 if (res.data.success) setWarehouses(res.data.data || []);
 } catch (_) {
 // ignore
 }
 };

 const fetchLedger = async () => {
 try {
 setLoading(true);
 const queryParams = new URLSearchParams();
 if (filters.search) queryParams.append("search", filters.search);
 if (filters.warehouse) queryParams.append("warehouse", filters.warehouse);
 if (filters.movementType) queryParams.append("movementType", filters.movementType);
 queryParams.append("page", filters.page);
 queryParams.append("limit", filters.limit);
 const res = await api.get(`/inventory-purchase-orders/stock/ledger?${queryParams.toString()}`);
 if (res.data.success) {
 setRows(res.data.data || []);
 setPagination(res.data.pagination || pagination);
 }
 } catch (error) {
 swal("Error", "Failed to load stock ledger", "error");
 } finally {
 setLoading(false);
 }
 };

 return (
 <Fragment>
 <PageTitle activeMenu="Stock Ledger" motherMenu="Inventory" />
 <Row>
 <Col lg={12}>
 <Card>
 <Card.Header className="d-flex justify-content-between align-items-center">
 <Card.Title className="mb-0">Stock Ledger</Card.Title>
 <Button variant="secondary" as={Link} to="/inventory-dashboard">Back</Button>
 </Card.Header>
 <Card.Body>
 <Row className="g-2 mb-3">
 <Col md={4}>
 <Form.Control
 placeholder="Search item / remarks"
 value={filters.search}
 onChange={(e) => setFilters((prev) => ({ ...prev, search: e.target.value }))}
 onKeyDown={(e) => e.key === "Enter" && fetchLedger()}
 />
 </Col>
 <Col md={4}>
 <Form.Select
 value={filters.warehouse}
 onChange={(e) => setFilters((prev) => ({ ...prev, warehouse: e.target.value, page: 1 }))}
 >
 <option value="">All Warehouses</option>
 {warehouses.map((wh) => (
 <option key={wh._id} value={wh._id}>
 {wh.warehouseName}
 </option>
 ))}
 </Form.Select>
 </Col>
 <Col md={2}>
 <Form.Select
 value={filters.movementType}
 onChange={(e) => setFilters((prev) => ({ ...prev, movementType: e.target.value, page: 1 }))}
 >
 <option value="">All Types</option>
 <option value="IN">IN</option>
 <option value="OUT">OUT</option>
 <option value="ISSUE">ISSUE</option>
 <option value="TRANSFER_IN">TRANSFER IN</option>
 <option value="TRANSFER_OUT">TRANSFER OUT</option>
 <option value="ADJUSTMENT">ADJUSTMENT</option>
 </Form.Select>
 </Col>
 <Col md={2}>
 <Button className="w-100" onClick={fetchLedger}>Search</Button>
 </Col>
 </Row>

 <div className="table-responsive">
 <Table hover>
 <thead>
 <tr>
 <th>Date</th>
 <th>Warehouse</th>
 <th>Item</th>
 <th>Type</th>
 <th>Counter WH</th>
 <th>Qty</th>
 <th>Rate</th>
 <th>Amount</th>
 <th>Balance</th>
 <th>PO</th>
 <th>Remarks</th>
 </tr>
 </thead>
 <tbody>
 {!loading && rows.map((row) => (
 <tr key={row._id}>
 <td>{row.movementAt ? new Date(row.movementAt).toLocaleDateString() : "-"}</td>
 <td>{row.warehouse?.warehouseName || "-"}</td>
 <td>{row.itemName}</td>
 <td>
 <Badge
 bg={
 row.movementType === "IN" || row.movementType === "TRANSFER_IN"
 ? "success"
 : row.movementType === "OUT" || row.movementType === "ISSUE" || row.movementType === "TRANSFER_OUT"
 ? "danger"
 : "warning"
 }
 >
 {row.movementType}
 </Badge>
 </td>
 <td>{row.counterWarehouse?.warehouseName || "-"}</td>
 <td>{Number(row.quantity || 0)}</td>
 <td>Rs. {Number(row.rate || 0).toFixed(2)}</td>
 <td>Rs. {Number(row.amount || 0).toFixed(2)}</td>
 <td>{Number(row.balanceAfter || 0)}</td>
 <td>{row.inventoryPurchaseOrder?.inventoryPoNumber || "-"}</td>
 <td>{row.remarks || "-"}</td>
 </tr>
 ))}
 {!loading && rows.length === 0 && (
 <tr>
 <td colSpan="11" className="text-center text-muted py-4">No ledger entries found</td>
 </tr>
 )}
 </tbody>
 </Table>
 </div>
 </Card.Body>
 </Card>
 </Col>
 </Row>
 </Fragment>
 );
};

export default InventoryStockLedger;
